import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=740fb0e6&scoped=true&"
import script from "./CreateProject.vue?vue&type=script&lang=ts&"
export * from "./CreateProject.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProject.vue?vue&type=style&index=0&id=740fb0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fb0e6",
  null
  
)

export default component.exports